/*
 * @Author: cryi.liu
 * @Date: 2020-04-30 09:46:53
 * @LastEditTime: 2020-04-30 09:55:04
 * @Description: write you description
 */

import { version } from '../../../package.json';

export default {
  namespaced: true,

  state: {
    name: 'saec',
    version,
  },

  getters: {
    name({ name }) {
      return name;
    },
    version(state) {
      return state.version;
    },
  },

  mutations: {

  },

  actions: {

  },
};
